import { reactive } from "vue";
import ConfigManager from "@/config/ConfigManager.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
import ConfigScript from "@/config/ConfigScript";

const state = reactive({
    tracking: null,
    isEnableTrack: false,
    trackingInit: false,
})

const methods = {
    initTracking: function () {
        let config = ConfigManager.getFirebaseSetup();
        let firebaseAnalytics = null;

        if (config.apiKey) {
            const configScript = new ConfigScript()
            configScript.useFirebase().then(async () => {
                await window.initFirebase(config);
                if (!window.isLockdown.isLockdownEnabled()) {
                    window.initAnalytics();
                }

                state.isEnableTrack = true;
                state.trackingInit = true;
            });
        } else {
            state.trackingInit = true;
        }
        state.tracking = new TrackingService(firebaseAnalytics)

    },
    getTracking: function() {
        return state.tracking
    },
    getIsEnableTrack: function() {
        return state.isEnableTrack
    },
    getIsTrackingInit: function() {
        return state.trackingInit
    }
}

export default {
    state: state,
    methods: methods,
}
